import { render, staticRenderFns } from "./placeTable.vue?vue&type=template&id=2a8600a9"
import script from "./placeTable.vue?vue&type=script&lang=js"
export * from "./placeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports